export const services = [
  {
    id: 1,
    number: "01",
    icon: "📡",
    title: "Wi-Fi-as-a-Service",
    description:
      "Reliable, secure, high-speed connectivity that turns your Wi-Fi network into a real-time customer engagement platform. Manage thousands of networks from one portal, gather customer behaviour data, and monetise your infrastructure with targeted advertising and multiple login tiers.",
    tags: [
      "Wi-Fi Management Portal",
      "Data Analytics & Intelligence",
      "Wi-Fi Advertising",
      "Branded Captive Portals",
    ],
    capabilities: [
      "Wi-Fi Management Portal \u2014 multi-site at scale",
      "Data Analytics & Customer Intelligence",
      "Wi-Fi Advertising & Targeted Marketing",
      "Paid & Free Network Monetisation",
      "Branded Captive Portal Experiences",
    ],
    image: "/images/wifi-as-service/wifi-as-service.gif",
    imageContain: true,
    featured: true,
    link: "/wifi-platform",
  },
  {
    id: 2,
    number: "02",
    icon: "💻",
    title: "Software & Digital Services",
    description:
      "Custom software solutions built to improve efficiency and drive digital transformation. We deliver everything from mobile apps and ERP systems to AI-powered platforms \u2014 built for African enterprise at African scale.",
    tags: [
      "Web & Mobile Apps",
      "AI Factory",
      "API & Systems Integration",
      "Azure Cloud",
    ],
    capabilities: [
      "Web, Mobile & App Development (Android, iOS)",
      "AI Factory \u2014 Intelligent Platform Development",
      "Database, API & Systems Integration",
      "ERP",
      "GIS Solutions",
      "Azure Cloud Infrastructure \u2014 Microsoft Partner",
    ],
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    featured: false,
    link: "/software-digital",
  },
  {
    id: 3,
    number: "03",
    icon: "🖥️",
    title: "Managed IT",
    description:
      "End-to-end managed network services and digital presence solutions. From LAN/WAN infrastructure and RF planning to Wi-Fi hotspot management and network monitoring. We handle your technology operations so you can focus on your business.",
    tags: [
      "Network Deployment",
      "LAN/WAN & Microwave",
      "Endpoint Protection",
      "Global Resourcing",
    ],
    capabilities: [
      "Network Planning, Deployment & Monitoring",
      "LAN, WAN, Microwave, P2P & Last-Mile",
      "Endpoint Protection & Remote Maintenance",
      "Network Monitoring",
      "Global resource sourcing with certified network engineers and technicians",
    ],
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    featured: false,
    link: "/managed-it",
  },
  {
    id: 4,
    number: "04",
    icon: "📈",
    title: "Business Consulting",
    description:
      "Strategic advisory that bridges technology and commercial outcomes. From market research and Telco programme management to go-to-market strategy and regulatory impact. We partner with clients for sustained, measurable growth.",
    tags: [
      "Market Research",
      "Telco Programme Management",
      "Go-To-Market Strategy",
      "Regulatory Impact",
    ],
    capabilities: [
      "Market Research & Consumer Insights",
      "Telco Programme Management & ISP Deployment",
      "Digital Transformation & Design Thinking",
      "Go-To-Market & Commercialisation Strategy",
      "Regulatory Impact & Obligations Funds",
    ],
    image:
      "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&q=80",
    featured: false,
    link: "/business-consulting",
  },
  {
    id: 5,
    number: "05",
    icon: "🤖",
    title: "AI Factory",
    description:
      "We design, develop, and deploy AI-powered platforms that automate complex workflows, surface intelligence from data, and enable smarter decision-making across enterprise and government. Built on models that understand the African context \u2014 not adapted from elsewhere.",
    tags: [
      "AI Platform Development",
      "Intelligent Automation",
      "NLP & Voice AI",
      "Government & Enterprise AI",
    ],
    capabilities: [
      "AI Platform Design & Development",
      "Intelligent Process Automation",
      "Natural Language Processing & Voice AI",
      "Data Analytics & Predictive Intelligence",
      "Government & Enterprise AI Solutions",
    ],
    image:
      "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&q=80",
    featured: false,
  },
];

export const pipelineStages = [
  {
    icon: "📡",
    title: "1. Build the Network",
    description:
      "Every digital platform begins with reliable infrastructure. Konecta designs and deploys enterprise-grade telecommunications networks across corporate environments, municipalities, public venues, and community infrastructure. Our networks are engineered for resilience, performance, and scalability — and designed to support the data platforms and intelligent services that organisations increasingly rely on.",
    tags: ["Wi-Fi-as-a-Service", "Managed Networks", "5G Advisory", "Last-Mile"],
  },
  {
    icon: "🗄️",
    title: "2. Develop the Platform",
    description:
      "Connectivity alone generates limited value. Intelligence emerges when networks are paired with intelligent software platforms. Konecta builds custom platforms that capture and process real-time network data, enabling organisations to understand how users interact with their digital environments. These platforms integrate APIs, analytics pipelines, and software systems capable of capturing behavioural data, usage patterns, and operational signals across large-scale environments.",
    tags: [
      "Custom Platforms",
      "API Development",
      "Data Collection",
      "IoT Integration",
    ],
  },
  {
    icon: "📊",
    title: "3. Generate Data & Analytics",
    description:
      "Once captured, network data becomes a powerful strategic resource. Konecta's analytics platforms transform raw data into actionable insights that enable organisations to make faster and more informed decisions. Through advanced analytics, clients gain visibility into customer behaviour, location intelligence, network performance, and service usage trends.",
    tags: [
      "Big Data",
      "Customer Insights",
      "Location Intelligence",
      "Behavioural Analytics",
    ],
  },
  {
    icon: "💎",
    title: "4. Enable Value Creation",
    description:
      "The final stage of Konecta's model converts insight into measurable business value. Through value-added services and digital platforms, clients can monetise connectivity, automate customer engagement, and introduce new digital products and services. This includes monetised portals, targeted digital engagement, operator integrations, content delivery platforms, and AI-driven decision systems.",
    tags: [
      "VAS Revenue",
      "Monetised Portals",
      "Content Delivery",
      "AI Insights",
    ],
  },
];

export const microsoftSolutions = [
  {
    icon: "☁️",
    title: "Microsoft Azure Cloud",
    description:
      "Architecture design, cloud migration, hybrid infrastructure, and managed Azure services for African enterprises — with local compliance and POPIA expertise built in.",
  },
  {
    icon: "🤖",
    title: "AI Adoption & Microsoft Copilot",
    description:
      "End-to-end AI deployment: Copilot for Microsoft 365, Azure AI services, and custom models integrated into your workflows. We guide organisations from AI-curious to AI-productive.",
  },
  {
    icon: "📋",
    title: "Microsoft 365 & Dynamics 365",
    description:
      "Full M365 deployment, licensing, and governance. Dynamics 365 CRM and ERP implementations tailored to African business contexts and regulatory requirements.",
  },
  {
    icon: "🔒",
    title: "Security & Compliance (POPIA)",
    description:
      "Microsoft Defender, Sentinel, and Purview deployments aligned to POPIA and African data governance for enterprise and government clients.",
  },
];

export const kaiFeatures = [
  {
    number: "01",
    title: "Production-Grade AI Deployment",
    description:
      "Konecta enables African enterprises and public sector organisations to deploy production-grade AI capabilities through strategic partnerships with global technology partners.",
  },
  {
    number: "02",
    title: "Network Infrastructure & Data Environments",
    description:
      "We provide the network infrastructure, data environments, and market integration required to capture and process large-scale data — along with enterprise AI infrastructure, cloud platforms, and cybersecurity architecture.",
  },
  {
    number: "03",
    title: "Fully Integrated AI Ecosystem",
    description:
      "Together, we deliver a fully integrated AI ecosystem — enabling organisations to deploy machine learning models, automate complex processes, and extract insight from vast data environments.",
  },
];
